module.exports = __webpack_public_path__ + "static/img/icon-password.d2b98e3d.png";